module.exports = __webpack_public_path__ + "static/media/sf-test-18.ab135409.mp3";